module.exports = __webpack_public_path__ + "asset/contract-doc--209ec1.png";